import { render, staticRenderFns } from "./EZUIPlayer.vue?vue&type=template&id=b9d1ffba&scoped=true"
import script from "./EZUIPlayer.vue?vue&type=script&lang=js"
export * from "./EZUIPlayer.vue?vue&type=script&lang=js"
import style0 from "./EZUIPlayer.vue?vue&type=style&index=0&id=b9d1ffba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d1ffba",
  null
  
)

export default component.exports